import { DrawingTool } from '../controllers/toolbar/interfaces'
import arrow_creator from './arrow'
import brush_v1_creator from './brush/brush_v1'
import callout_v1_creator from './callout/callout_v1'
import curve_creator from './curve'
import elliott_waves_creator from './elliott_waves/elliott_waves'
import ellipse_v1_creator from './ellipse/ellipse_v1'
import fibonacci_creator from './fibonacci_retracements'
import horizontalLine_creator from './horizontal_line'
import measure_creator from './measure'
import pitchfork_v1_creator from './pitchfork/pitchfork_v1'
import polygon_creator from './polygon'
import position_creator from './position'
import rectangle_creator from './rectangle'
import rotatedRectangle_v1_creator from './rotated_rectangle/rotated_rectangle_v1'
import scaledLine_creator from './scaled_line'
import scaledText_creator from './scaled_text'
import arrow_touch_creator from './touch/arrow'
import brush_v1_touch_creator from './touch/brush/brush_v1'
import callout_v1_touch_creator from './touch/callout/callout_v1'
import curve_touch_creator from './touch/curve'
import elliott_waves_touch_creator from './touch/elliott_waves/elliott_waves'
import ellipse_v1_touch_creator from './touch/ellipse/ellipse_v1'
import fibonacci_touch_creator from './touch/fibonacci_retracements'
import horizontalLine_touch_creator from './touch/horizontal_line'
import measure_touch_creator from './touch/measure'
import pitchfork_v1_touch_creator from './touch/pitchfork/pitchfork_v1'
import polygon_touch_creator from './touch/polygon'
import position_touch_creator from './touch/position'
import rectangle_touch_creator from './touch/rectangle'
import rotatedRectangle_v1_touch_creator from './touch/rotated_rectangle/rotated_rectangle_v1'
import scaledLine_touch_creator from './touch/scaled_line'
import scaledText_touch_creator from './touch/scaled_text'
import triangle_touch_creator from './touch/triangle'
import verticalLine_touch_creator from './touch/vertical_line'
import xabcd_touch_creator from './touch/xabcd'
import triangle_creator from './triangle'
import verticalLine_creator from './vertical_line'
import xabcd_creator from './xabcd'

export const drawingToolsCreatorsByType = Object.freeze({
  [DrawingTool.Arrow]: arrow_creator,
  [DrawingTool.Brush]: brush_v1_creator,
  [DrawingTool.Callout]: callout_v1_creator,
  [DrawingTool.Curve]: curve_creator,
  [DrawingTool.ElliottWaves]: elliott_waves_creator,
  [DrawingTool.Ellipse]: ellipse_v1_creator,
  [DrawingTool.FibonacciRetracements]: fibonacci_creator,
  [DrawingTool.HorizontalLine]: horizontalLine_creator,
  [DrawingTool.Measure]: measure_creator,
  [DrawingTool.Pitchfork]: pitchfork_v1_creator,
  [DrawingTool.Polygon]: polygon_creator,
  [DrawingTool.Position]: position_creator,
  [DrawingTool.Rectangle]: rectangle_creator,
  [DrawingTool.RotatedRectangle]: rotatedRectangle_v1_creator,
  [DrawingTool.ScaledLine]: scaledLine_creator,
  [DrawingTool.ScaledText]: scaledText_creator,
  [DrawingTool.Triangle]: triangle_creator,
  [DrawingTool.VerticalLine]: verticalLine_creator,
  [DrawingTool.Xabcd]: xabcd_creator,
})

export const drawingToolsTouchCreatorsByType = Object.freeze({
  [DrawingTool.Arrow]: arrow_touch_creator,
  [DrawingTool.Brush]: brush_v1_touch_creator,
  [DrawingTool.Callout]: callout_v1_touch_creator,
  [DrawingTool.Curve]: curve_touch_creator,
  [DrawingTool.ElliottWaves]: elliott_waves_touch_creator,
  [DrawingTool.Ellipse]: ellipse_v1_touch_creator,
  [DrawingTool.FibonacciRetracements]: fibonacci_touch_creator,
  [DrawingTool.HorizontalLine]: horizontalLine_touch_creator,
  [DrawingTool.Measure]: measure_touch_creator,
  [DrawingTool.Pitchfork]: pitchfork_v1_touch_creator,
  [DrawingTool.Polygon]: polygon_touch_creator,
  [DrawingTool.Position]: position_touch_creator,
  [DrawingTool.Rectangle]: rectangle_touch_creator,
  [DrawingTool.RotatedRectangle]: rotatedRectangle_v1_touch_creator,
  [DrawingTool.ScaledLine]: scaledLine_touch_creator,
  [DrawingTool.ScaledText]: scaledText_touch_creator,
  [DrawingTool.Triangle]: triangle_touch_creator,
  [DrawingTool.VerticalLine]: verticalLine_touch_creator,
  [DrawingTool.Xabcd]: xabcd_touch_creator,
})
